<div class="d-flex flex-row gap-2">
  <div *ngFor="let icon of icons; let index = index;" class="opacity-75 text-success"
    title="{{existSlot(index) ? (getDate(getSlots[index]) | date:'yyyy-MM-dd | HH:mm:ss') : '' }}"
    style="min-width: 16px; min-height: 16px;">
    <i *ngIf="existSlot(index)" class="{{icon}} text-danger"></i>
    <i *ngIf="!existSlot(index)" class="{{icon}}"></i>
  </div>
  <div *ngIf="cards_counter != undefined" class="opacity-50 ms-1 space-nowrap">+ {{cards_counter}}</div>
</div>